import {
  dateFormats,
  formatDateTime,
  printRoundedNumber,
} from '../../shared/utils';

export type DataTransformer<T> = (arg: T) => string;

export const dataTransformers = {
  integer: (amount: number) => `${printRoundedNumber(amount, 0)}`,
  date: (date: Date | string) => formatDateTime(date, dateFormats.date),
  createCustomDate: (format: string) => (date: Date | string) =>
    formatDateTime(date, format || dateFormats.date),
  boolean: (data: boolean) => (data ? 'Yes' : 'No'),
  currency: (amount: number) => `$ ${printRoundedNumber(amount, 2, true)}`,
  currencyHighAccuracy: (amount: number) =>
    `$ ${printRoundedNumber(amount, 5, true)}`,
  inches: (amount: number) => `${amount}in`,
  unit: (unit: string, round: number) => (amount: number) =>
    `${printRoundedNumber(amount, round, true)} ${unit}`,
};
